import React, { memo } from 'react';
import classnames from 'classnames/bind';
import { TrashOutlineIcon } from "../../../icons";
import { getFileName } from "../../utils/getFileName";
import styles from "./styles.pcss";
var cn = classnames.bind(styles);
export var FileInfo = /*#__PURE__*/memo(function (_ref) {
  var onFileDelete = _ref.onFileDelete,
    name = _ref.name,
    size = _ref.size,
    error = _ref.error,
    index = _ref.index;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cn('file__text'),
    "data-t-id": "components-FileInfo"
  }, getFileName(name), /*#__PURE__*/React.createElement("button", {
    className: cn('file__button'),
    id: String(index),
    onClick: onFileDelete,
    type: "button"
  }, /*#__PURE__*/React.createElement(TrashOutlineIcon, {
    fill: "#5a5e62",
    size: 16
  }))), /*#__PURE__*/React.createElement("p", {
    className: cn('file__size', {
      'file--error': !!error
    })
  }, size || error));
});